import {
  binCountSessionIdFormat,
  productIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";

const BinStatus = z.object({
  storageLocationId: storageLocationIdFormat.schema,
  binName: z.string(),
  countedAt: z.date().nullable(),
  deletedAt: z.date().nullable(),
});

export const getBinCountSession = {
  name: "getBinCountSession" as const,
  input: z.object({ binCountSessionId: binCountSessionIdFormat.schema }),
  output: z.object({
    binCountSessionId: binCountSessionIdFormat.schema,
    productId: productIdFormat.schema.nullable(),
    productTitle: z.string().nullable(),
    productSku: z.string().nullable(),
    marketplaceBin: z.string().nullable(),
    bins: z.array(BinStatus),
    completedAt: z.date().nullable(),
    deletedAt: z.date().nullable(),
    createdAt: z.date(),
  }),
};
